// extracted by mini-css-extract-plugin
export default {"root":"AllActiveUsersSidebar_root__7PAdj"};